import { gql } from 'graphql-tag'

export const PAYMENT_QUERY = gql`
  query paymentQuery($token: String!, $paymentId: String!, $locale: Lang!) {
    payment(id: $paymentId, token: $token) {
      id
      amount
      currency
      paymentMethod
      paymentStatus
      token
    }

    paymentResource(token: $token, locale: $locale) {
      currency
      list {
        checkInDate
        checkOutDate
        currency
        descriptions {
          count
          description
        }
        title
        price
      }
      resourceType
      subTotal
      taxAmount
      total
    }
  }
`
